import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pdf-container",
  id: "pdf-container"
}
const _hoisted_2 = {
  key: 0,
  class: "spinner-wrapper"
}
const _hoisted_3 = {
  key: 1,
  id: "pdf-wrapper",
  class: "pdf-wrapper"
}
const _hoisted_4 = { class: "ban-container" }
const _hoisted_5 = {
  key: 2,
  id: "pdf-wrapper",
  class: "pdf-wrapper"
}
const _hoisted_6 = { class: "ban-container" }
const _hoisted_7 = { class: "links-container" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.guideNumPages < 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ion_spinner, { name: "lines" })
            ]))
          : _createCommentVNode("", true),
        (_ctx.guideNumPages >= 0 && !_ctx.releaseEntity.guideOffline)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guideNumPages, (page) => {
                return (_openBlock(), _createBlock(_component_ion_img, {
                  key: page,
                  class: "guide-page",
                  id: `guide-page-${page}`,
                  src: `${_ctx.guidePath}/${page > 9 ? page : '0' + page}${_ctx.guideToken ? '?token=' + encodeURIComponent(_ctx.guideToken) : ''}`,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLinksContainerVisibility()))
                }, null, 8, ["id", "src"]))
              }), 128)),
              _withDirectives(_createElementVNode("div", _hoisted_4, [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: _ctx.ban
                }, null, 8, ["icon"])
              ], 512), [
                [_vShow, _ctx.guideNumPages == 0]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.guideNumPages >= 0 && _ctx.releaseEntity.guideOffline)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guidePages, (page, idx) => {
                return (_openBlock(), _createBlock(_component_ion_img, {
                  class: "guide-page",
                  key: page.name,
                  src: `${_ctx.guidePath}/${page.name}${_ctx.guideToken ? '?token=' + encodeURIComponent(_ctx.guideToken) : ''}`,
                  id: `guide-page-${idx + 2}`,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLinksContainerVisibility()))
                }, null, 8, ["src", "id"]))
              }), 128)),
              _withDirectives(_createElementVNode("div", _hoisted_6, [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: _ctx.ban
                }, null, 8, ["icon"])
              ], 512), [
                [_vShow, _ctx.guideNumPages == 0]
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("div", {
            class: "guide-link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollTop()))
          }, [
            _createVNode(_component_ion_icon, {
              slot: "icon-only",
              icon: _ctx.arrowUpOutline
            }, null, 8, ["icon"])
          ], 512), [
            [_vShow, _ctx.showScrollTop]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "guide-link",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expandLinks = !_ctx.expandLinks))
          }, [
            _createVNode(_component_ion_icon, {
              slot: "icon-only",
              icon: _ctx.menu
            }, null, 8, ["icon"])
          ], 512), [
            [_vShow, false]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, idx) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "guide-link",
              key: idx,
              onClick: ($event: any) => (_ctx.scrollTop(link.destPage))
            }, _toDisplayString(idx + 1), 9, _hoisted_8)), [
              [_vShow, _ctx.expandLinks]
            ])
          }), 128))
        ], 512), [
          [_vShow, _ctx.showLinksContainer || !_ctx.showScrollTop]
        ])
      ])
    ]),
    _: 1
  }))
}